import { combineReducers } from "redux"

import dialogs from "./dialogs"
import radiometric_viewer from "../containers/radiometric-viewer/reducers"

export default combineReducers({
    dialogs,
    radiometric_viewer
})